import { FieldTypes } from 'drapcode-constant';
import { findParentCollection } from '../collectionTraits/utils';
import { fieldTraitTextContentOptions } from '../dataGroup/traitsApi';
import { getCollectionFields } from '../pluginComponentApi';
import { bngPaymentType } from './consts';

export default async function (editor, opts = {}) {
  const domc = editor.DomComponents;
  const defaultType = domc.getType('default');
  const defaultModel = defaultType.model;
  const defaultView = defaultType.view;
  const { pfx, classPfx, projectId, collections, bngConfig } = opts;
  domc.addType(bngPaymentType, {
    model: defaultModel.extend(
      {
        defaults: {
          ...defaultModel.prototype.defaults,
          icon: '<i class="wb webconnect-cart-check"></i>',
          droppable: ':not(form)',
          draggable: ':not(form)',
          collectionName: '',
          projectId: projectId,
          resizable: true,
          traits: [
            ...defaultModel.prototype.defaults.traits,
            {
              type: 'content',
              label: 'Text',
            },
          ],
        },
        async init() {
          const collectionName = findParentCollection(this, opts);
          if (collectionName) {
            const collectionResponse = await getCollectionFields(collectionName, collections);
            if (collectionResponse) {
              const textTraitsOptions = await fieldTraitTextContentOptions(
                collectionResponse,
                collections,
              );
              if (textTraitsOptions) {
                const { lineItemType } = bngConfig;
                if (!lineItemType || lineItemType === 'purchase') {
                  this.addTrait({
                    label: 'SKU Field',
                    name: 'data-item-sku',
                    title: 'sku',
                    type: 'data-bng-payment-trait',
                    options: textTraitsOptions,
                  });
                  this.addTrait({
                    label: 'Quantity Field',
                    name: 'data-item-quantity',
                    title: 'Quantity',
                    type: 'data-bng-payment-trait',
                    options: textTraitsOptions,
                  });
                } else if (lineItemType === 'customPayment') {
                  this.addTrait({
                    label: 'Description Field',
                    name: 'data-item-description',
                    title: 'description',
                    type: 'data-bng-payment-trait',
                    options: textTraitsOptions,
                  });
                }
              }
              const { fields } = collectionResponse;
              const collectionReferenceFields =
                fields && fields.length > 0
                  ? fields.filter((crd) => crd.type === FieldTypes.reference.id)
                  : [];
              this.setAttributes({
                selectedCollectionData: JSON.stringify(collectionReferenceFields),
                onclick: 'bngPaymentCheckout(event)',
              });
            }
          }
        },
      },
      {
        isComponent(el) {
          if (el.getAttribute && el.getAttribute('data-gjs-type') === bngPaymentType) {
            return {
              type: bngPaymentType,
            };
          }
        },
      },
    ),
    view: defaultView.extend({
      events: {
        submit(e) {
          e.preventDefault();
        },
      },
      init({ model }) {
        this.listenTo(this.model, 'change:content', this.updateContent);
        this.listenTo(model, 'change:data-item-sku', this.updateScript);
        this.listenTo(model, 'change:data-item-quantity', this.updateScript);
        this.listenTo(model, 'change:data-item-price', this.updateScript);
      },
      updateContent() {
        if (this.model.get('content')) {
          this.el.innerHTML = this.model.get('content');
        }
      },
    }),
  });
}
